import { Button, Icon, Text } from '@chakra-ui/react'
import { FiFile, FiFileText, FiImage } from 'react-icons/fi'

interface SourcePillProps {
  name: string
  mimeType: string
  onClick: () => void
}

function iconFor(mimeType: string) {
  if (mimeType?.startsWith('image/')) return FiImage
  if (mimeType === 'application/pdf') return FiFile
  return FiFileText
}

/**
 * A document a chat answer cited, rendered as a clickable pill.
 *
 * Long filenames truncate rather than wrapping, so a row of pills stays one line tall.
 */
export default function SourcePill({ name, mimeType, onClick }: SourcePillProps) {
  return (
    <Button
      size="xs"
      variant="outline"
      borderRadius="full"
      borderColor="brand.200"
      color="brand.600"
      fontWeight="normal"
      fontSize="xs"
      maxW="220px"
      leftIcon={<Icon as={iconFor(mimeType)} boxSize="12px" />}
      _hover={{ bg: 'brand.50', borderColor: 'brand.300' }}
      onClick={onClick}
      title={name}
    >
      <Text noOfLines={1}>{name}</Text>
    </Button>
  )
}
